module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice_grid_ui-f99e9f3a2b41073ce2dc3cbabf787f22.webp";